import { filter, find, findIndex } from 'lodash';
import { observable, action, makeObservable } from 'mobx'
import IPage from '../interfaces/IPage';

export default class PageStore {

     list: IPage[] = [];

    
    addRecords(records: IPage[]): any {
        if (records.length > 0) {
            records.forEach((record: IPage) => this.addRecord(record));
        }
    }

    
    private addRecord(record: IPage) {
        if (!record) {
            return;
        }

        const index = findIndex(this.list, { id: record.id });
        if (index >= 0) {
            this.list.splice.apply(this.list, [index, 1, record]);
        } else {
            this.list.push(record);
        }
    }

    public getById(id: string): IPage {
        return find(this.list, { id: id });
    }

    public getByIds(ids: string[]): IPage[] {
        return filter(this.list, item => {
            if (ids.includes(item.id)) {
                return true;
            }
            return false;
        })
    }

    public getByUserId(userId: string): IPage[] {
        return filter(this.list, { userId: userId });
    }

    public removeById(id: string) {
        this.list = filter(this.list, item => {
            if (item.id != id) {
                return true;
            }
            return false;
        })
    }

    constructor() {
        makeObservable(this, {
            list: observable,
            addRecords: action,
            removeById: action,
        })
    }
}